/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Suspense } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { CssBaseline, useMediaQuery, CircularProgress } from "@material-ui/core";
import Loader from "@icarius-common/loader";
import { AudioPlayer } from "@icarius-common/audioPlayer";
import { GridProcessResultDialog } from "@icarius-common/gridProcessResultDialog";
import { Poll } from "@icarius-common/poll";
import { createTheme } from "@icarius-utils/theme";
import { LG_DEVICE_WIDTH_BREAKPOINT } from "@icarius-utils/constants";
import { Home } from "@icarius-pages/home";
import useTheme from "./hooks/useTheme";
import useWrapper from "./hooks/useWrapper";
import Menu from "./menu";
import Header from "./header";
import Footer from "./footer";
import Dialogs from "./dialogs";
import CommandPalette from "./commandPalette";
import ErrorBoundary from "../../../common/errorBoundary";

const Wrapper = () => {

  const {
    isLoading,
    color,
    availablePaths,
    allRoutes,
    customRoutes,
    canChangeRole,
    dialogsState,
    changeSocietyData,
    drawerIsOpen,
    setDrawerIsOpen,
    handleOpenItem,
  } = useWrapper();

  const { theme, handleToggleTheme } = useTheme();
  const matchesMoreOrEqualThanLG = useMediaQuery(`(min-width:${LG_DEVICE_WIDTH_BREAKPOINT}px)`);
  const location = useLocation();

  return (
    <MuiThemeProvider theme={createTheme(theme?.theme, color)}>
      <div id="menu-container">
        <Loader open={isLoading} />
        {
          Boolean(availablePaths?.length > 0) &&
          <>
            <Header
              withDrawerToggle={!matchesMoreOrEqualThanLG}
              routes={allRoutes}
              dialogsState={dialogsState}
              handleRegisterAssistance={() => dialogsState.setAssistanceDialogIsOpen(true)}
              handleToggleDrawer={() => setDrawerIsOpen((prev) => !prev)}
              handleToggleTheme={handleToggleTheme}
              handleOpenItem={handleOpenItem}
            />
            <div id="drawer-container" className={matchesMoreOrEqualThanLG ? "autoHide" : ""} style={{ position: "relative" }}>
              <CssBaseline />
              <Menu
                open={drawerIsOpen}
                variant={matchesMoreOrEqualThanLG ? "permanent" : "temporary"}
                customRoutes={customRoutes}
                availablePaths={availablePaths}
                showChangeSocietyMenuItem={changeSocietyData.canChangeSociety}
                showChangeRoleMenuItem={canChangeRole}
                handleOpenItem={handleOpenItem}
                handleClose={() => setDrawerIsOpen(false)}
              />
              <main className="page" style={{ marginTop: matchesMoreOrEqualThanLG && "65px", display: 'flex', flexDirection: 'column' }}>
                <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '400px' }}><CircularProgress /></div>}>
                  <ErrorBoundary key={location.pathname}>
                    <Switch>
                      {
                        allRoutes.map(route =>
                          <Route
                            key={route.path}
                            path={route.path}
                            component={route.component}
                            exact
                          />
                        )
                      }
                      <Route component={Home} />
                    </Switch>
                  </ErrorBoundary>
                </Suspense>
              </main>
              <Dialogs
                dialogsState={dialogsState}
                changeSocietyData={changeSocietyData}
              />
            </div>
            <Footer onSocietyClick={() => changeSocietyData.canChangeSociety && changeSocietyData.handleOpenChangeSocietyDialog()} />
            <GridProcessResultDialog />
            <Poll />
            <AudioPlayer />
            <CommandPalette
              availablePaths={availablePaths}
              routes={allRoutes}
              customRoutes={customRoutes}
              handleOpenItem={handleOpenItem}
              dialogsState={dialogsState}
              handleToggleTheme={handleToggleTheme}
            />
          </>
        }
        <a id="downloadAnchorElem" style={{ display: "none" }} />
      </div>
    </MuiThemeProvider>
  )
}

export default Wrapper;